import { useState, useEffect, useContext } from "react";
import { MultiSelect } from "../../components/menu/multiSelect";
import { AuthContext } from "../../contexts/AuthContext";
import { useAuthFetch } from "../../hooks/useAuthFetch";

function DashboardUserFilter({ selected, onUpdate, onClear }) {
  const [usersOptions, setUsersOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { authContext } = useContext(AuthContext);
  const orgId = authContext.organization.orgId;
  const authFetch = useAuthFetch();

  const fetchUsers = async () => {
    if (!orgId) return;

    try {
      const response = await authFetch(
        `${process.env.REACT_APP_API_URL}/v1/users/shifts?org_id=${orgId}`
      );

      if (response.ok) {
        const data = await response.json();

        const augmentedData = data.map((user) => ({
          ...user,
          name: `${user.first_name} ${user.last_name}`,
          is_active: Boolean(user.is_active), // Convert to boolean
        }));

        setUsersOptions(augmentedData);
        setIsLoading(false);
      } else {
        console.error("Error fetching users:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    if (orgId) {
      fetchUsers();
    }
  }, [orgId]);

  return (
    <MultiSelect
      label="Guards"
      options={usersOptions}
      onUpdate={onUpdate}
      onClear={onClear}
      selected={selected}
      isLoading={isLoading}
      optionStatus="true"
    />
  );
}

export { DashboardUserFilter };
